import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import PreLoadImage from './PreLoadImage';
import { formatDate1} from '../libs/utils';
import { Autoplay } from 'swiper';
const MobileHomeProgram = ({
  list,
  title,
  setSwiperRef,
  swiperNext,
  swiperPrev,
  scrollPos,
  mobile,
  Config,
  images
}) => {
  const [hoveredList, setHoveredList] = useState([]);

  const handleMouseOver = (index) => {
    const updatedList = [...hoveredList];
    updatedList[index] = true;
    setHoveredList(updatedList);
  };

  const handleMouseOut = (index) => {
    const updatedList = [...hoveredList];
    updatedList[index] = false;
    setHoveredList(updatedList);
  };

  return (
    <div className='mobile secondProPar'>
      <div className="secondProTit">{title}</div>
      <div className="m-flex-row-center programSlideBox">
        <button className='h32' onClick={swiperPrev}>
          <img src={images.img110} className='w20 invertBtn' alt='' />
        </button>
        <Swiper
          onSwiper={(ref) => setSwiperRef(ref)}
          autoHeight={true}
          spaceBetween={15}
          navigation={false}
          loop={true}  
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          direction='horizontal'
          effect='slide'
          breakpoints={{
            0: {
              slidesPerView: 2,  // 768px 이하일 때 슬라이드 1개
            },
            768: {
              slidesPerView: 2,  // 768px 이상일 때 슬라이드 2개
            },
          }}
          modules={[Autoplay]} 
        >
          {list.map((data, index) => {
            const now = new Date();
            const sDateTime = new Date(data.s_date_time);
            const diffInTime = sDateTime.getTime() - now.getTime();
            const diffInDays = diffInTime / (1000 * 3600 * 24);
            const isCloseToEnd = data.expire === 0 && (data.cnt - data.cnt_temp <= Math.max(data.cnt * 0.1, 3));
            const isSoldOut = data.cnt <= data.cnt_temp;

            return (
              <SwiperSlide
                key={index}
                className={scrollPos > (mobile ? 30 : 120) ? `mobileProgram fade-up-ani ani-delay-${100 * (index + 2)}` : 'mobileProgram'}
              >
                <button
                  className='relative ofh'
                  onMouseOver={() => handleMouseOver(index)}
                  onMouseOut={() => handleMouseOut(index)}
                  onClick={() => window.location = '/programDetail?id=' + data.id}
                >
                  <PreLoadImage className={'bg-img1'} url={Config.IMG_URL + data.img} data={data} />
                  {(data.start === 1 && data.expire === 1) && <span className='status bg999'>판매완료</span>}
                  {data.expire === 0 && <span className='status'>신청진행중</span>}
                  
                  <div className='b-txt'>
                    <p className='homeTitle'><span className="TitleName">{data.name}</span><span class="styleWhite">-</span>      
                    {(() => {
                    const publishDate = new Date(data.publish_date); 
                    const currentDate = new Date(); 
                    const diffInDays = Math.floor((currentDate - publishDate) / (1000 * 60 * 60 * 24)); 

                    if (diffInDays >= 0 && diffInDays <= 7) {
                      return <><span className="newbadge">NEW</span><span class="styleWhite">-</span></>
                    }
                  })()}
                  {isSoldOut && <div className="purpleNameBtn">전석매진</div>}
                    {isCloseToEnd && !isSoldOut && data.always !="Y" && <div className="redNameBtn">마감임박</div>}</p>
                    <p className='homeShort'>{data.short}</p>
                    <p className='homeLast'>
                      <span className='LastInner'>{data.cat_name}</span>
                      <span className='LastDivider'>|</span>
                      {data.healer_name !== '' && (
                        <>
                          <span className='LastInner'>{data.healer_name}</span>
                          <span className='LastDivider'>|</span>
                        </>
                      )}
                      <span className='LastInner'>{data.always === "Y" ? '상시신청' : '진행일시 ' + formatDate1(data.s_date)}</span>
                    </p>
                  </div>
                </button>
              </SwiperSlide>
            );
          })}
        </Swiper>
        <button className='h32' onClick={swiperNext}>
          <img src={images.img111} className='w20 invertBtn' alt='' />
        </button>
      </div>
    </div>
  );
};

export default MobileHomeProgram;
